import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/permission'
import '@/utils/flexible'

// 全局修改 $message 样式大小
const style = document.createElement('style')
style.innerHTML = `
  .el-message {
    font-size: 14px !important;
  }
  .el-message__content {
    font-size: 14px !important;
  }
  .el-message--success .el-message__closeBtn,
  .el-message--error .el-message__closeBtn,
  .el-message--warning .el-message__closeBtn,
  .el-message--info .el-message__closeBtn {
    font-size: 14px !important;
  }
`
document.head.appendChild(style)

Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
